// @need-translate
import Head from 'next/head';

import {getEnv} from '../common/env/env';
import {MetaInfo} from './MetaInfo.interface';

export function MetaHead({metaInfo = {}}: {metaInfo?: MetaInfo}) {
  // null 로 들어올 땐 기본 {} 세팅이 안되는 것 같은데 확인이 필요해보입니다. null 로 들어오는 이유와 {} 세팅이 안되는 이유.
  // 이 코드가 빠지면 metaInfo 가 null 이라 잘못된 접근 에러가 납니다
  if (metaInfo === null) {
    metaInfo = {};
  }
  const {
    title = '카카오페이지',
    author,
    description = '오리지널 독점 웹툰, 웹소설 부터 책 까지 한 곳에서 즐기세요. 인기 콘텐츠가 기다리면 무료!',
    keywords = '카카오페이지, kakaopage, 오리지널, 웹툰, 웹소설, 영화, 만화, 책, 예능, 드라마, 콘텐츠, 기다리면 무료',
    url = getEnv().webOrigin,
    image = 'https://page.kakaocdn.net/pageweb/ogImage.png',
    ogTitle = '카카오페이지',
    additionalMetaList = [],
  } = metaInfo;
  const metaImage = image.includes('http') ? image : `https:${image}`; //  meta 이미지에 https 가 없으면 못읽어가는 사이트가 있어 추가

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'Organization',
            name: '카카오페이지',
            url: 'https://page.kakao.com',
            sameAs: [
              'https://www.instagram.com/kakaopage/',
              'https://www.facebook.com/page.kakao',
              'https://www.youtube.com/@kakaopage.official',
              'https://twitter.com/kakaopage',
              'https://apps.apple.com/kr/app/id616643813',
              'https://play.google.com/store/apps/details?id=com.kakao.page',
            ],
          }),
        }}
      ></script>
      <meta name="service" content="kakaopage" />
      <meta name="keywords" content={keywords} />
      <meta name="description" content={description} />
      {author && <meta name="author" content={author} />}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="ko_KR" />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="카카오페이지" />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={metaImage} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:image" content={metaImage} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:site" content="@kakaopage" />
      <meta name="twitter:creator" content="@kakaopage" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="fb:app_id" content="574884132543436" />
      <meta property="article:author" content="카카오페이지" />
      <meta property="article:section" content="연재물" />
      {additionalMetaList.map((additionalMeta, index) => (
        <meta key={index} {...additionalMeta} />
      ))}
    </Head>
  );
}
